import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddSuccessSnackbarComponent } from '../../../dialogs/add-success-snackbar/add-success-snackbar.component';
import { FacultyModel } from '../../../model/faculty.model';
import { FacultyFellowshipSpecialisationModel } from '../../../model/faculty_fellowship_specialisation.model';
import { FacultyService } from '../../../providers/faculty.service';
import { FacultyFellowshipSpecialisationService } from '../../../providers/faculty_fellowship_specialisation.service';
import { Location } from '@angular/common';

@Component({
	selector: 'app-fellowship-specialisation-add-dialog',
	templateUrl: './fellowship-specialisation-add-dialog.component.html',
	styleUrls: [ './fellowship-specialisation-add-dialog.component.css' ]
})
export class FellowshipSpecialisationAddDialogComponent implements OnInit {
	newItem: FacultyFellowshipSpecialisationModel;
	mItems: FacultyFellowshipSpecialisationModel[];
	mFaculty: FacultyModel;
	durationInSeconds = 1;
	errorMessage: string = '';
	isLoading: boolean = true;

	constructor(
		private fb: FormBuilder,
		private mApiService: FacultyFellowshipSpecialisationService,
		public facultyService: FacultyService,
		private location: Location,
		private _snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<FellowshipSpecialisationAddDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.newItem = new FacultyFellowshipSpecialisationModel();
		this.mFaculty = new FacultyModel();
	}

	ngOnInit(): void {
		this.mFaculty = this.facultyService.mFaculty;
	}

	getItemsList(id: string) {
		this.mItems = [];
		this.isLoading = true;

		this.mApiService
			.getItems(id)
			.subscribe((p) => (this.mItems = p), (e) => (this.errorMessage = e), () => (this.isLoading = false));
	}

	saveNewItem() {
		this.newItem.FacultyId = this.mFaculty.Id;
		// console.log(this.newItem);
		this.mApiService.addItem(this.newItem).subscribe(
			(p) => {
				this.dialogRef.close();
				this._snackBar.openFromComponent(AddSuccessSnackbarComponent, {
					duration: this.durationInSeconds * 1000
				});

				this.newItem = new FacultyFellowshipSpecialisationModel();
				// this.getItemsList(this.mFaculty.Id);
				this.location.back();
			},
			(e) => (this.errorMessage = e),
			() => (this.isLoading = false)
		);
	}
}
